<template>
  <div id="">
    <modal :open="true" :loading="false">
      <template slot="header">
        <h1 class="emd-text _size_page">{{$t('delete.title')}}</h1>
      </template>
      <template slot="content">
        <div class="emd-section _separator">
          <error-list :items="errors"></error-list>
          <form action="javascript:void(0)" @submit.prevent="deleteDevApp" novalidate="true" ref="deleteForm">
            <fieldset>
              <div class="emd-form-group">
                <label class="emd-label u-required" for="password">{{$t('delete.password')}}:</label>
                <input name="name" class="emd-input" id="password" type="password" v-model="body.password" v-on:focusout="form.validateInput" required>
              </div>
            </fieldset>
            <fieldset>
              <div class="emd-flex">
                <div class="emd-flex-item _shrink">
                  <button class="emd-btn _color_secondary" type="submit" :disabled="!formIsValid">{{$t('delete.confirm')}}</button>
                </div>
                <div class="emd-flex-item _shrink">
                  <router-link class="emd-btn _color_primary _type_text" type="button" :to="{ name: 'home'}">{{$t('delete.cancel')}}</router-link>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import Modal from '@/components/project/Modal.vue'
import ErrorList from '@/components/project/ErrorList.vue'
import form from '@/plugins/form.js'

export default {
  name: 'DeleteApplication',
  components: {
    Modal,
    ErrorList
  },
  data () {
    return {
      body: {
        password: ''
      },
      form: form,
      formIsValid: false,
      errors: []
    }
  },
  methods: {
    deleteDevApp (e) {
      e.preventDefault()
      const elements = Object.assign([], e.target.elements)
      const invalidElements = elements.filter(e => e.validity.valid === false)
      const body = Object.assign({}, this.body)
      const publicAppKey = this.$route.params.publicAppKey

      if (invalidElements.length === 0) {
        const submitButton = elements.filter(e => e.type === 'submit')[0]
        submitButton.classList.add('_state_loading')

        this.$store.dispatch('DELETE_APP', { publicAppKey, body })
          .then(response => {
            window.scrollTo(0, 0)
            this.errors = []
            submitButton.classList.remove('_state_loading')
            this.$router.push({ name: 'home' })
          })
          .catch(response => {
            this.errors = []
            if (response.status === 401) {
              this.errors.push({ message: this.$t('delete.401') })
            } else if (response.status === 400) {
              this.errors.push({ message: this.$t('delete.400') })
            } else if (response.status === 404) {
              this.errors.push({ message: this.$t('delete.404') })
            } else {
              this.errors.push({ message: this.$t('delete.500') })
            }
            submitButton.classList.remove('_state_loading')
          })
      } else {
        form.addInputError(invalidElements[0])
      }
    }
  },
  updated () {
    this.formIsValid = this.$refs.deleteForm.checkValidity()
  }
}
</script>
